<template>
  <div>
    <applications-supplier-header></applications-supplier-header>
    <applications-supplier-navigation></applications-supplier-navigation>
    <applications-supplier-steps></applications-supplier-steps>
  </div>
</template>

<script>
import ApplicationsSupplierHeader from './header';
import ApplicationsSupplierNavigation from './navigation';
import ApplicationsSupplierSteps from './steps/';

export default {
  name: 'ApplicationsSupplier',
  components: {
    ApplicationsSupplierHeader,
    ApplicationsSupplierNavigation,
    ApplicationsSupplierSteps,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    async getApplication() {
      if (this.id) {
        await this.$store.commit('setIsAppLoading', true);
        await this.$store.dispatch('supplier/fetchApplication', this.id);
        await this.$store.commit('setIsAppLoading', false);
        await this.checkApplication();
      } else {
        await this.$store.commit('supplier/resetApplication');
      }
    },
    async checkApplication() {
      if (!this.$store.getters['supplier/getId']) {
        this.$notify({
          title: 'Başvuru Formu Bulunamadı',
          text: 'Sistemde kayıtlı böyle bir başvuru bulunamadı',
        });
        await this.$store.commit('supplier/setSavedApplicationId', null);
        setTimeout(() => {
          this.$router.push({ name: 'applications.supplier' });
        });
      }
    },
    async checkIfUserCanResumeApplication() {
      const savedApplicationId = this.$store.getters[
        'supplier/getSavedApplicationId'
      ];

      if (!this.id && savedApplicationId) {
        const title = 'Kayıtlı Tedarikçi Başvurusu';
        const body = `
          Daha önceden yarım bıraktığınız bir başvuru bulunmaktadır. Devam etmek ister misiniz?
          <br><br>
          <em><b>Not:</b> Hayır'ı seçerseniz daha oluşturmuş olduğunuz kayıtlı başvurunuz silinecektir.</em>
        `;

        const isConfirmed = await this.$confirm({ title, body });

        if (isConfirmed) {
          this.$router.replace({
            params: {
              id: savedApplicationId,
            },
          });
        } else {
          await this.$store.commit('supplier/setSavedApplicationId', null);
        }
      }
    },
  },
  async created() {
    await this.checkIfUserCanResumeApplication();
    await this.getApplication();
  },
  beforeDestroy() {
    this.$confirmCloseAll();
  },
  async destroyed() {
    await this.$store.commit('supplier/resetApplication');
  },
};
</script>
